import { render } from "./TenantNotificationSetting.vue?vue&type=template&id=2ef198a7"
import script from "./TenantNotificationSetting.vue?vue&type=script&lang=js"
export * from "./TenantNotificationSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__